import React from 'react';

export default class OverlayFooter extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer-container">
          <div className="row row--with_margin h-full align-items-center">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
